import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';

export function matchFieldsValidator(fieldToCompare: FormControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: object } | null => {
    const forbidden = control.value.trim() != "" && control.value.trim() != fieldToCompare.getRawValue().trim();
    return forbidden ? { 'match': { value: control.value.trim() } } : null;
  };
}